/* eslint-disable */
import GraphQL from '../types/graphql';

import CK from '~/types/contentking';
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type AccountLogoUrlQueryVariables = GraphQL.Exact<{
  accountId: GraphQL.Scalars['AccountId']['input'];
}>;


export type AccountLogoUrlQuery = { readonly __typename?: 'Query', readonly account: { readonly __typename?: 'Account', readonly id: CK.AccountId, readonly logoUrl: string | null } | null };


export const AccountLogoUrlDocument = gql`
    query AccountLogoUrl($accountId: AccountId!) {
  account(id: $accountId) {
    id
    logoUrl
  }
}
    `;

/**
 * __useAccountLogoUrlQuery__
 *
 * To run a query within a React component, call `useAccountLogoUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccountLogoUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccountLogoUrlQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useAccountLogoUrlQuery(baseOptions: Apollo.QueryHookOptions<AccountLogoUrlQuery, AccountLogoUrlQueryVariables> & ({ variables: AccountLogoUrlQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AccountLogoUrlQuery, AccountLogoUrlQueryVariables>(AccountLogoUrlDocument, options);
      }
export function useAccountLogoUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AccountLogoUrlQuery, AccountLogoUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AccountLogoUrlQuery, AccountLogoUrlQueryVariables>(AccountLogoUrlDocument, options);
        }
export function useAccountLogoUrlSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AccountLogoUrlQuery, AccountLogoUrlQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AccountLogoUrlQuery, AccountLogoUrlQueryVariables>(AccountLogoUrlDocument, options);
        }
export type AccountLogoUrlQueryHookResult = ReturnType<typeof useAccountLogoUrlQuery>;
export type AccountLogoUrlLazyQueryHookResult = ReturnType<typeof useAccountLogoUrlLazyQuery>;
export type AccountLogoUrlSuspenseQueryHookResult = ReturnType<typeof useAccountLogoUrlSuspenseQuery>;
export type AccountLogoUrlQueryResult = Apollo.QueryResult<AccountLogoUrlQuery, AccountLogoUrlQueryVariables>;